import { render, staticRenderFns } from "./UserActivePermit.vue?vue&type=template&id=533d512d&scoped=true"
import script from "./UserActivePermit.vue?vue&type=script&lang=js"
export * from "./UserActivePermit.vue?vue&type=script&lang=js"
import style0 from "./UserActivePermit.vue?vue&type=style&index=0&id=533d512d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d512d",
  null
  
)

export default component.exports